// extracted by mini-css-extract-plugin
module.exports = {"overlay":"GradientOverlay_overlay__T2KMD"};